<template>
	<Teleport to="body">
		<Transition name="modal-fade" v-if="showSubModal">
			<div
				class="subscription-modal-backdrop"
				@click.self="closeModal"
				role="dialog"
				aria-modal="true"
				aria-labelledby="subscriptionModalTitle"
				aria-describedby="subscriptionModalDescription">
				<div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content shadow-lg border-0 rounded-lg p-3">
						<div class="modal-header border-bottom-0 text-center d-block pb-0">
							<button
								type="button"
								class="btn-close position-absolute top-0 end-0 m-3"
								aria-label="Close"
								@click="closeModal"></button>
							<h5 class="modal-title w-100" id="subscriptionModalTitle">
								<i class="bi bi-gem text-warning me-2 fs-4 align-middle"></i>
								<span class="align-middle">Plus Subscription Required</span>
							</h5>
							<h6 class="modal-subtitle">LOCKED FEATURE: {{ subFeature }}</h6>
						</div>

						<div
							class="modal-body text-center px-4 px-sm-5 py-4"
							id="subscriptionModalDescription">
							<p class="lead mb-3">
								This feature is exclusive to our
								<strong class="text-primary">Plus</strong> subscribers!
							</p>
							<p class="mb-3">
								Upgrade today to unlock this and many other plus benefits designed
								to enhance your experience.
							</p>
							<!-- <p class="text-muted small mb-4">
							<i class="bi bi-phone me-1"></i>
							Please note: Subscription management is currently handled through
							our mobile app.
						</p>

						<div v-if="isNative" class="d-grid gap-2">
							<button class="btn btn-primary btn-lg" @click="goToBilling">
								<i class="bi bi-gear-fill me-2"></i>
								Manage Subscription
							</button>
						</div>
						<div v-else>
							<p class="fst-italic text-muted small">
								(Get our mobile app to subscribe and manage your account)
							</p>
						</div>-->
						</div>

						<div
							class="modal-footer border-top-0 justify-content-center pt-0 pb-4 gap-4">
							<button
								type="button"
								class="btn btn-outline-secondary"
								@click="closeModal">
								Maybe Later
							</button>
							<button class="btn btn-primary" @click="goToBilling">
								Go to Subscription
							</button>
						</div>
					</div>
				</div>
			</div>
		</Transition>
	</Teleport>
</template>

<script setup>
	import { ref, onMounted, watch, onUnmounted } from "vue"
	import { useRouter } from "vue-router"
	import { Capacitor } from "@capacitor/core"
	import { showSubModal, subFeature } from "@/utils/subscriptionBus"

	// --- State ---
	const isNative = ref(false)
	const router = useRouter()

	// --- Methods ---
	const closeModal = () => {
		showSubModal.value = false
	}

	const goToBilling = () => {
		router.push("/subscription") // Navigate to your billing/subscription page
		closeModal() // Close modal after initiating navigation
	}

	const checkPlatform = () => {
		isNative.value = Capacitor.isNativePlatform()
	}

	// --- Lifecycle & Watchers ---
	onMounted(() => {
		checkPlatform()
		// Optional: Add ESC key listener
		// window.addEventListener("keydown", handleEscKey)
	})

	// Clean up listener when component is unmounted or modal is hidden
	watch(
		() => showSubModal.value,
		(newValue) => {
			if (newValue) {
				// window.addEventListener("keydown", handleEscKey)
				// Prevent body scroll when modal is open
				document.body.style.overflow = "hidden"
			} else {
				// window.removeEventListener("keydown", handleEscKey)
				// Restore body scroll
				document.body.style.overflow = ""
			}
		}
	)

	// Handler for Escape key
	// const handleEscKey = (event) => {
	// 	if (event.key === "Escape" && props.modelValue) {
	// 		closeModal()
	// 	}
	// }

	// Ensure cleanup on unmount just in case
	onUnmounted(() => {
		// window.removeEventListener("keydown", handleEscKey)
		// Ensure body scroll is restored if component unmounts while modal is open
		if (showSubModal.value) {
			document.body.style.overflow = ""
		}
	})
</script>

<style scoped>
	.subscription-modal-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.65); /* Slightly darker backdrop */
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2147483647;
		padding: 1rem; /* Add padding for smaller screens */
	}

	/* Ensure modal itself doesn't trigger backdrop close */
	.modal-dialog {
		/* Optional: Add max-width if needed */
		max-width: 500px;
		width: 100%;
		pointer-events: auto; /* Allow clicks inside modal */
	}

	.modal-content {
		pointer-events: auto; /* Ensure clicks work inside content */
		background-color: #fff; /* Explicit background */
	}

	/* Style the icon */
	.modal-title i.bi-gem {
		font-size: 1.75rem; /* Make icon a bit larger */
		vertical-align: -0.25em; /* Fine-tune vertical alignment */
	}

	/* Fade Transition */
	.modal-fade-enter-active,
	.modal-fade-leave-active {
		transition: opacity 0.3s ease;
	}

	.modal-fade-enter-from,
	.modal-fade-leave-to {
		opacity: 0;
	}

	/* Optional: Add a slight scale effect */
	.modal-fade-enter-active .modal-dialog {
		transition: transform 0.3s ease-out;
	}
	.modal-fade-leave-active .modal-dialog {
		transition: transform 0.2s ease-in;
	}

	.modal-fade-enter-from .modal-dialog,
	.modal-fade-leave-to .modal-dialog {
		transform: scale(0.95);
	}
</style>
